export const GET_USER = 'GET_USER';
export const SET_USER = 'SET_USER';
export const CREATE_PROFILE = 'CREATE_PROFILE';
export const SYNC_USER = 'SYNC_USER';
export const USER_LOGOUT = 'USER_LOGOUT';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const EDIT_PROFILE = 'EDIT_PROFILE';
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION';
export const SET_FILTER_DATA = 'SET_FILTER_DATA';
export const SET_USER_RATING = 'SET_USER_RATING';
export const GET_USER_RATING = 'GET_USER_RATING';
export const SET_USER_PROVIDER = 'SET_USER_PROVIDER';

export interface AddressProps {
  street: string;
  city: string;
  note?: string;
}

export interface LocationState {
  lat?: number;
  lng?: number;
}

export interface DateState {
  from: string;
  to: string;
}

export interface UserDetails {
  userid: string;
  authComplete?: boolean;
  accountType: string;
  subAccountType: string;
  email: string;
  firstName?: string;
  lastName: string;
  username?: string;
  description?: string;
  phone?: string;
  address: AddressProps;
  image?: string;
  status: string;
  location: LocationState;
}

export interface Ratings {
  id: string;
  rate: number;
  user: string;
}

export interface User {
  user: UserDetails;
  currentLocation?: LocationState;
  dataFilter: FilterData;
  ratings: Ratings[];
  providername: string;
}

export interface ProfileDetails {
  username: string;
  description: string;
  image: string;
  filename: string;
  phone?: string;
  address: AddressProps;
  location: LocationState;
}

export interface FilterData {
  isFilter: boolean;
  distance: number;
  category: any[];
  restrictions: any[];
  selectedDate: DateState;
  // consumption: string;
  // price: number | [number, number];
  constantOffer: boolean;
  keyword?: string;
}

export interface Profile {
  details: ProfileDetails;
}

export interface UserAction {
  type: typeof SET_USER;
  user: UserDetails;
  currentLocation?: LocationState;
  dataFilter: FilterData;
  ratings: Array<Ratings>;
  providername: string;
}

export interface GetUserAction {
  type: typeof GET_USER;
  id: string;
}

export interface CreateProfileAction extends User {
  type: typeof CREATE_PROFILE;
  details: ProfileDetails;
}

export interface UpdateProfileAction extends User {
  type: typeof UPDATE_PROFILE;
  details: ProfileDetails;
}

export interface EditProfileAction extends User {
  type: typeof EDIT_PROFILE;
  details: UserDetails;
}

export interface LogoutAction extends User {
  type: typeof USER_LOGOUT;
}

export interface SetCurrentLocationAction extends User {
  type: typeof SET_CURRENT_LOCATION;
  currentLocation?: LocationState;
}

export interface SetFilterDataACtion extends User {
  type: typeof SET_FILTER_DATA;
  dataFilter: FilterData;
}

export interface SetUserRatingAction extends User {
  type: typeof SET_USER_RATING;
  ratings: Ratings[];
}

export interface GetUserRatingAction extends User {
  type: typeof GET_USER_RATING;
}

export interface SetUserProviderAction extends User {
  type: typeof SET_USER_PROVIDER;
  providername: string;
}

export type UserActionTypes =
  | UserAction
  | CreateProfileAction
  | LogoutAction
  | UpdateProfileAction
  | SetCurrentLocationAction
  | SetFilterDataACtion
  | GetUserRatingAction
  | SetUserRatingAction
  | SetUserProviderAction;
